import API from './API';

export default {

  getPoints(text){
    return API.post('/planner/open-street-geocode', text)
  },

  addBooking(booking) {
    return API.post('/booking/', booking);
  },

  addBookingNotification(data) {
    return API.post('/booking/messageNewBooking/', data);
  },

  calcSlot(deatl) {
    return API.post('/planner/slot-availables/', deatl);
  },

  // upload via istanza condivisa: baseURL, Authorization e refresh token li mette API.js
  upload(file, mail) {
    return API.post('/booking/upload/' + mail, file, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  mailCustomer(mail){
    return API.get('/booking/mailCustomer/'+mail)
  },

  uploadModify(file, mail) {
    return API.post('/booking/upload-modify/' + mail, file, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  mailCustomerModify(mail){
    return API.get('/booking/mailCustomerModify/'+mail)
  },

  addTask(task){
    return API.post('/task', task)
  },

  calcDuration(data){
    return API.post('/planner/best-driver', data)
  },

}